import { render } from "./RegisterSmallModal.vue?vue&type=template&id=143a804e"
import script from "./RegisterSmallModal.vue?vue&type=script&lang=js"
export * from "./RegisterSmallModal.vue?vue&type=script&lang=js"

import "./RegisterSmallModal.vue?vue&type=style&index=0&id=143a804e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__